module.exports = __webpack_public_path__ + "static/media/grey-trash-icon.90b0175d.svg";